(function () {
  var path = window.location.pathname || '';
  var isCscFinder = /^\/pages\/csc-finder(?:\/)?$/.test(path);
  var isCscDetail = /^\/pages\/csc(?:\/|$)/.test(path);
  var isCscLanding = /^\/pages\/cannabis-social-club-eintragen(?:\/)?$/.test(path);
  if (!isCscFinder && !isCscDetail && !isCscLanding) return;

  var storageKey = 'cs_csc_age_gate_confirmed_v1';
  var redirectUrl = '/';

  function getConfirmed() {
    try {
      return window.localStorage.getItem(storageKey) === 'yes';
    } catch (error) {
      return false;
    }
  }

  function setConfirmed() {
    try {
      window.localStorage.setItem(storageKey, 'yes');
      window.localStorage.setItem(storageKey + '_at', new Date().toISOString());
    } catch (error) {
      // localStorage may be unavailable in strict privacy modes; the current session can still continue.
    }
  }

  if (getConfirmed()) return;

  var overlay = document.createElement('div');
  overlay.className = 'cs-csc-age-gate';
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');
  overlay.setAttribute('aria-labelledby', 'cs-csc-age-gate-title');
  overlay.innerHTML = [
    '<div class="cs-csc-age-gate__panel">',
    '  <p class="cs-csc-age-gate__eyebrow">CannaSelection CSC-Finder</p>',
    '  <h2 class="cs-csc-age-gate__title" id="cs-csc-age-gate-title">Bist du mindestens 18 Jahre alt?</h2>',
    '  <p class="cs-csc-age-gate__text">Diese Website ist nur für Besucher ab 18 Jahren bestimmt.</p>',
    '  <p class="cs-csc-age-gate__text">Diese Altersbestätigung ist erforderlich, um fortzufahren.</p>',
    '  <div class="cs-csc-age-gate__actions">',
    '    <button class="cs-csc-age-gate__button cs-csc-age-gate__button--primary" type="button" data-cs-csc-age-yes>Klar, ich bin 18+</button>',
    '    <button class="cs-csc-age-gate__button cs-csc-age-gate__button--secondary" type="button" data-cs-csc-age-no>Sorry, ich bin unter 18</button>',
    '  </div>',
    '  <p class="cs-csc-age-gate__note">Die Bestätigung wird nur für diesen Browser gespeichert.</p>',
    '</div>'
  ].join('');

  function lockPage() {
    document.documentElement.classList.add('cs-csc-age-gate-lock');
    document.body.classList.add('cs-csc-age-gate-lock');
  }

  function unlockPage() {
    document.documentElement.classList.remove('cs-csc-age-gate-lock');
    document.body.classList.remove('cs-csc-age-gate-lock');
  }

  function showUnderageMessage() {
    var panel = overlay.querySelector('.cs-csc-age-gate__panel');
    if (!panel) return;
    panel.innerHTML = [
      '<p class="cs-csc-age-gate__eyebrow">Hinweis</p>',
      '<h2 class="cs-csc-age-gate__title">Zugang nicht möglich</h2>',
      '<p class="cs-csc-age-gate__text">Vielen Dank. Leider ist diese Seite erst ab 18 Jahren zugänglich.</p>',
      '<p class="cs-csc-age-gate__text">Du wirst jetzt weitergeleitet.</p>'
    ].join('');
    window.setTimeout(function () {
      window.location.assign(redirectUrl);
    }, 1800);
  }

  function trapFocus(event) {
    if (event.key !== 'Tab') return;
    var focusable = overlay.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function mount() {
    document.body.appendChild(overlay);
    lockPage();
    overlay.addEventListener('keydown', trapFocus);
    overlay.querySelector('[data-cs-csc-age-yes]').addEventListener('click', function () {
      setConfirmed();
      unlockPage();
      overlay.remove();
    });
    overlay.querySelector('[data-cs-csc-age-no]').addEventListener('click', showUnderageMessage);
    window.setTimeout(function () {
      var yesButton = overlay.querySelector('[data-cs-csc-age-yes]');
      if (yesButton) yesButton.focus();
    }, 60);
  }

  if (document.body) mount();
  else document.addEventListener('DOMContentLoaded', mount, { once: true });
})();
